import React from 'react';
import {
	PageWrapper,
	PageContent,
	MainHeader,
	Paragraph,
	LogoWrapper,
	Logo,
	BigCircle
} from 'styled/Layout';
import ziploLogo from 'assets/images/ziplo_logo.svg';
import gtvLogo from 'assets/images/gtv_logo.svg';
import {ReactComponent as StarsIcon} from 'assets/icons/stars.svg';
import {ReactComponent as CrossIcon} from 'assets/icons/cross.svg';
import {useNavigate, useLocation} from 'react-router';
import ScreenFooter from 'components/ScreenFooter';

const Info = () => {
	const navigate = useNavigate();
	const location = useLocation();
	
	if (!location.state) {
		navigate('/not-found', { replace: true });
		return null;
	}

	const content = location.state;

	return (
		<PageWrapper>
			<LogoWrapper>
				<Logo src={process.env.REACT_APP_BRAND === 'ziplo' ? ziploLogo : gtvLogo} />
			</LogoWrapper>
			<PageContent>
				<BigCircle>
					{content && content.success ? <StarsIcon /> : <CrossIcon />}
				</BigCircle>
				<MainHeader>{content && content.title}</MainHeader>
				<Paragraph>{content && content.desc}</Paragraph>
				<ScreenFooter />
			</PageContent>
		</PageWrapper>
	);
};

export default Info;
